module.exports = __webpack_public_path__ + "Roboto-Medium.4d9f3f9e5195e7b074bb.eot";


//////////////////
// WEBPACK FOOTER
// /revet-web/src/assets/fonts/Roboto-Medium.eot
// module id = ../../../../../src/assets/fonts/Roboto-Medium.eot
// module chunks = styles